import GoogleMapWrapper from "../../../../Components/GoogleMapWrapper";

const MessageLocation = ({message}) => {
    try {
        const jsonObject = typeof message.text === 'string' ? JSON.parse(message.text) : message.text;
        let {body, name} = jsonObject;
        body = body.split(';');
        const LatLng = {
            lat: Number(body[0]),
            lng: Number(body[1])
        }
        return <>
            <GoogleMapWrapper
                location={LatLng}
                marker={LatLng}
                zoom={6}
                width="100%"
                height="130px"
                style={name ? {borderRadius: '5px 5px 0px 0px'} : {
                    borderRadius: 5,
                    marginBottom: 8
                }}
            />
            {name && <div className="i-chats-dialogue-content-message-text i-chats-dialogue-content-message-text-location">
                <span><span>{name}</span></span>
                <span className="i-chats-dialogue-content-message-text-block"></span>
            </div>}
        </>
    } catch (err) {
        console.log(err);
        return <div className="i-chats-dialogue-content-message-text">
            <span><span>{message.text}</span></span>
            <span className="i-chats-dialogue-content-message-text-block"></span>
        </div>
    }
}

export default MessageLocation;